import Flat from './Flat'

export default Flat
